import { Adapter as r } from "../../../../adapter.js";
import { CashbackRecordModel as o } from "./cashbackRecord.model.js";
class c extends r {
  adapt(e) {
    return new o({
      id: e.id,
      timestamp: new Date(e.timestamp * 1e3),
      balance: e.balance,
      value: e.value,
      action: e.action,
      configuration: e.configuration,
      status: e.status,
      notes: e.notes,
      executedBy: e.executed_by,
      order: e.order ? {
        id: e.order.id,
        ticketNumber: e.order.ticket_number,
        payment: e.order.payment
      } : void 0
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  c as CashbackRecordAdapter
};
//# sourceMappingURL=cashbackRecord.adapter.js.map
